import React from 'react'
import {
  FancyModal,
  FancyContent,
  FancyShowcase,
  Avatar,
  FullBlockLoader,
  CircleLoader
} from '@deal/components'
import { BusinessUserToShareComponent } from '#src/generated/graphql'
import FacebookShare from '../FacebookShare'
import EmailIcon from '../share-email.svg'
import LinkIcon from '../share-link.svg'
import FacebookIcon from '../share-facebook.svg'
import styles from './styles.css'
import { withRouter, RouteComponentProps } from 'react-router-dom'

interface ShareProps extends RouteComponentProps<{}> {
  onRequestClose: () => void
  onEmailShare: () => void
  onLinkShare: () => void
  businessUserId: string
  shareUrl: string
}

class ShareProfileModal extends React.PureComponent<ShareProps, {}> {
  public render() {
    const { businessUserId, onRequestClose, onEmailShare, onLinkShare, shareUrl } = this.props

    return (
      <BusinessUserToShareComponent
        variables={{
          id: businessUserId
        }}
      >
        {({ data, loading }) => {
          if (loading) {
            return <FullBlockLoader loader={CircleLoader} />
          } else if (data && data.businessUser) {
            const businessUser = data.businessUser
            const category =
              businessUser.expertAttributes && businessUser.expertAttributes.categories[0]
            const categoryName = category && category.singularDisplayName

            return (
              <FancyModal isOpen={true} onRequestClose={onRequestClose}>
                <FancyShowcase className={styles.expertShowcase}>
                  {businessUser.expertProfile &&
                    businessUser.expertProfile.profilePhoto && (
                      <Avatar
                        name={`${businessUser.firstName} ${businessUser.lastName}`}
                        size={160}
                        src={businessUser.expertProfile.profilePhoto.url}
                        className={styles.expertAvatar}
                      />
                    )}

                  <div className={styles.expertDetails}>
                    <div className={styles.expertName}>{businessUser.firstName}</div>
                    {businessUser.expertProfile &&
                      categoryName && (
                        <div className={styles.expertHeadline}>your {categoryName} expert</div>
                      )}
                  </div>
                </FancyShowcase>
                <FancyContent className={styles.expertContent}>
                  <>
                    <div className={styles.shareContainer}>
                      <div className={styles.title}>Spread the love and hook your friends up</div>
                      <div className={styles.subTitle}>
                        {`Invite friends to shop with ${
                          businessUser.firstName
                        }. Get $25 for every friend that purchases and they get $25 too!`}
                      </div>
                      <div className={styles.links}>
                        <FacebookShare shareUrl={shareUrl}>
                          {share => (
                            <div className={styles.facebookLink} onClick={() => share()}>
                              <div className={styles.linkLeft}>
                                <FacebookIcon className={styles.facebookIcon} />
                              </div>
                              <div className={styles.linkCenter}>Share on Facebook </div>
                              <div className={styles.linkRight} />
                            </div>
                          )}
                        </FacebookShare>
                        <div className={styles.emailLink} onClick={onEmailShare}>
                          <div className={styles.linkLeft}>
                            <EmailIcon className={styles.icon} />
                          </div>
                          <div className={styles.linkCenter}>Share via email </div>
                          <div className={styles.linkRight} />
                        </div>

                        <div className={styles.linkLink} onClick={onLinkShare}>
                          <div className={styles.linkLeft}>
                            <LinkIcon className={styles.icon} />
                          </div>
                          <div className={styles.linkCenter}>Share with a link </div>
                          <div className={styles.linkRight} />
                        </div>
                      </div>
                    </div>
                  </>
                </FancyContent>
              </FancyModal>
            )
          }
          return null
        }}
      </BusinessUserToShareComponent>
    )
  }
}

export default withRouter(ShareProfileModal)
